export enum MOBILE_NAVIGATION {
    /**
     * @value Add an element
     * @description Title of the dialog opened when clicking the "add element" button
     */
    ADD_ELEMENT = 'ADMIN.MOBILE.NAVIGATION.ADD_ELEMENT',
    /**
     * @value To ease the mobile user experience, navigation is limited to three levels.
     * @description Text to display next to Add section button when depth limit is reached
     */
    DEPTH_LIMIT = 'ADMIN.MOBILE.NAVIGATION.DEPTH_LIMIT',
    /**
     * @value Element
     * @description Label of the "add element" button on the mobile navigation admin
     */
    ELEMENT_BUTTON = 'ADMIN.MOBILE.NAVIGATION.ELEMENT_BUTTON',
    /**
     * @value Organize content to define the Explore tab
     * @description The description displayed when the mobile navigation admin is empty
     */
    EMPTY_LIST_DESCRIPTION = 'ADMIN.MOBILE.NAVIGATION.EMPTY_LIST_DESCRIPTION',
    /**
     * @value Define Explore
     * @description Title appearing when the mobile navigation admin is empty
     */
    EMPTY_LIST_TITLE = 'ADMIN.MOBILE.NAVIGATION.EMPTY_LIST_TITLE',
    /**
     * @value External link
     * @description In Mobile Navigation admin page, the title of the dialog to add external links as navigation item.
     */
    EXTERNAL_LINK_DIALOG_TITLE = 'ADMIN.MOBILE.NAVIGATION.EXTERNAL_LINK.DIALOG_TITLE',
    /**
     * @value Navigation
     * @description Label of the "add navigation" button on the mobile navigation admin
     */
    NAVIGATION_BUTTON = 'ADMIN.MOBILE.NAVIGATION.NAVIGATION_BUTTON',
    /**
     * @value Pick community
     */
    PICK_COMMUNITY = 'ADMIN.MOBILE.NAVIGATION.PICK_COMMUNITY',
    /**
     * @value Pick communities from all platform sites
     * @description Description of the "pick communities" option listed in the "add element" dialog
     */
    PICK_COMMUNITY_DESCRIPTION = 'ADMIN.MOBILE.NAVIGATION.PICK_COMMUNITY_DESCRIPTION',
    /**
     * @value Pick communities
     * @description Title of the "pick communities" option listed in the "add element" dialog
     */
    PICK_COMMUNITY_TITLE = 'ADMIN.MOBILE.NAVIGATION.PICK_COMMUNITY_TITLE',
    /**
     * @value Pick content
     */
    PICK_CONTENT = 'ADMIN.MOBILE.NAVIGATION.PICK_CONTENT',
    /**
     * @value Pick content from your platform
     * @description Description of the "pick content" option listed in the add element dialog
     */
    PICK_CONTENT_DESCRIPTION = 'ADMIN.MOBILE.NAVIGATION.PICK_CONTENT_DESCRIPTION',
    /**
     * @value Pick content
     * @description Title of the "pick content" option listed in the add element dialog
     */
    PICK_CONTENT_TITLE = 'ADMIN.MOBILE.NAVIGATION.PICK_CONTENT_TITLE',
    /**
     * @value Link external content with URL
     * @description Description of the "pick external content" option listed in the "add element" dialog
     */
    PICK_EXTERNAL_CONTENT_DESCRIPTION = 'ADMIN.MOBILE.NAVIGATION.PICK_EXTERNAL_CONTENT_DESCRIPTION',
    /**
     * @value Link external content
     * @description Title of the "pick external content" option listed in the "add element" dialog
     */
    PICK_EXTERNAL_CONTENT_TITLE = 'ADMIN.MOBILE.NAVIGATION.PICK_EXTERNAL_CONTENT_TITLE',
    /**
     * @value Navigation entries allow grouping elements. A new navigation entry will be created in the menu.
     */
    SECTION_DIALOG_BODY = 'ADMIN.MOBILE.NAVIGATION.SECTION.DIALOG_BODY',
    /**
     * @value Navigation
     * @description Add section modal title
     */
    SECTION_DIALOG_TITLE = 'ADMIN.MOBILE.NAVIGATION.SECTION.DIALOG_TITLE',
    /**
     * @value Navigation
     * @description Title of the mobile navigation administration
     */
    TITLE = 'ADMIN.MOBILE.NAVIGATION.TITLE',
    /**
     * @value Label
     * @description In Mobile navigation admin page, the label of the Title input.
     */
    TITLE_FIELD_LABEL = 'ADMIN.MOBILE.NAVIGATION.EXTERNAL_LINK.TITLE_FIELD.LABEL',
    /**
     * @value This URL is invalid.
     * @description In mobile navigation admin page, the error message displayed when the user type an invalid url in the URL input
     */
    URL_FIELD_ERROR_MESSAGE = 'ADMIN.MOBILE.NAVIGATION.EXTERNAL_LINK.URL_FIELD.ERROR_MESSAGE',
    /**
     * @value URL
     * @description In Mobile navigation admin page, the label of the URL input.
     */
    URL_FIELD_LABEL = 'ADMIN.MOBILE.NAVIGATION.EXTERNAL_LINK.URL_FIELD.LABEL',
    /**
     * @value You can add a maximum of 200 elements within a navigation item.
     * @description Text to display  next to Add element button in admin mobile navigation when max node navigation is reached
     */
    WIDTH_LIMIT = 'ADMIN.MOBILE.NAVIGATION.WIDTH_LIMIT',
}
